import { z } from 'zod/v4';

import { foldSynonyms, isNumber, isString, normalizeFlatArgs } from '../widget-schemas/fold-helpers';
import { INDEX_SYNONYM_KEYS } from '../widget-schemas/reorder-widget.schema';

import { BLOCK_ID_SYNONYM_KEYS } from './remove-block.schema';

/**
 * Blocks are the page's top-level list, so there is no parent to move between — only an index. That
 * makes this the one reorder tool with no optional target-parent field.
 */
const reorderBlockObjectSchema = z.object({
    blockId: z.string().describe('Id of the block to move.'),
    index: z
        .number()
        .int()
        .min(0)
        .describe(
            'Destination position on the page (0-based, counted with this block already taken out of the ' +
                'list) — 0 puts it at the very top. Larger than the list is clamped to the end.'
        ),
});

export const reorderBlockArgsSchema = z.preprocess(
    (raw) =>
        normalizeFlatArgs(raw, (args) => {
            foldSynonyms(args, args, 'blockId', BLOCK_ID_SYNONYM_KEYS, isString);
            foldSynonyms(args, args, 'index', INDEX_SYNONYM_KEYS, isNumber);
        }),
    reorderBlockObjectSchema
);
